module.exports = __webpack_public_path__ + "media/images/sp/stores/fukuoka/fukuoka_sns_05-69184006955e805940af549850713c64.jpg";